import React from 'react'
import Barcode from 'react-barcode'
import ShippingLines from './shipping_lines'
import OrderNotes from './order_notes'

export default class PrintSummaryTable extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    let rows = []
    let keys = ["title", "variant_title", "quantity", "sku", "order_count"]
    if (this.props.showBarcodes) keys.push("barcode")
    if (this.props.showImages) keys.unshift("image")

    for (let i = 0; i < this.props.rows.length; i++) {
      let sli = this.props.rows[i]
      let filterString = sli.title + sli.variant_title + sli.sku;
      if (!filterString.includes(this.props.filter)) {
        continue;
      }
      let columns = []
      for (let j = 0; j < keys.length; j++) {
        let column = sli[keys[j]]
        if (j == 0 && column && column != "" && this.props.showImages) {
          // it's the image row
          column = <img src={column} height="50px" />
        }
        if (j == keys.length - 1 && column && column != "" && this.props.showBarcodes)
          column = <Barcode value={column} width={1} height={25} margin={0} fontSize={12} margin={5} textMargin={1} key={'columnbarcode' + j} />
        columns.push(
          <td
            key={'column' + j}
            style={
              {
                border: "1px solid #ddd",
                textAlign: "center"
              }
            }
          >
            {column}
          </td>
        )
      }
      rows.push(
        <tr key={i}>{columns}</tr>
      )

      if (this.props.showShippingLines) {
        let containsShipping =
          sli.order_ids
            .find(order_id => {
              return this.props.order_address_map[order_id]
            })

        if (containsShipping) {
          rows.push([<tr key={"print" + i} className="print-shipping-line">
            <td colSpan="10">
              <ShippingLines summary_line_item={sli} order_address_map={this.props.order_address_map} order_notes={this.props.order_notes}></ShippingLines>
            </td>
          </tr>
          ])
        }
      }
    }

    let headings = ["Product", "Variant", "Quantity", "SKU Number", "Cont. Orders"]
    if (this.props.showBarcodes) headings.push("Barcode")
    if (this.props.showImages) headings.unshift("Image")

    let tableHeadings = []
    for (let i = 0; i < headings.length; i++)
      tableHeadings.push(
        <th
          style={
            {
              border: "1px solid #ddd"
            }
          }
          key={i}
        >{headings[i]}</th>
      )

    return (
      <div id="print-table">
        <h3>PiknPak order summary</h3>
        <table style={{ borderCollapse: "collapse", minWidth: "100%" }}>
          <thead>
            <tr style={{ fontWeight: "lighter" }}>{tableHeadings}</tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
        <p><strong>Cont. Orders:</strong> The total number of orders in which this product variant is contained.</p>
        {this.props.showShippingLines &&
          <>
            <p><strong>Order notes</strong></p>
            <OrderNotes order_notes={this.props.order_notes}></OrderNotes>
          </>
        }
      </div>
    )
  }
}